import React, { FC, useState } from 'react'
import { Button, ButtonProps, Modal } from 'react-bootstrap'

type WarningModalProps = {
  onSelection?: () => void
  modalButtonProps: ModalButtonProps[]
  warningText: string
}

export type ModalButtonProps = Pick<ButtonProps, 'variant'> & {
  text: string
  action?: () => void
}

export const WarningModal: FC<WarningModalProps> = ({
  onSelection,
  modalButtonProps,
  warningText,
}) => {
  const [show, setShow] = useState(true)

  const handleClose = () => setShow(false)

  const closingActionFactory = (action?: () => void) => () => {
    if (action) {
      action()
    }
    if (onSelection) {
      onSelection()
    }
    handleClose()
  }

  const buttonFactory = (buttonProps: ModalButtonProps[]) => {
    return buttonProps.map(({ text, variant, action }, i) => {
      return (
        <Button
          variant={variant}
          onClick={closingActionFactory(action)}
          key={i}>
          {text}
        </Button>
      )
    })
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Body>{warningText}</Modal.Body>
      <Modal.Footer>{buttonFactory(modalButtonProps)}</Modal.Footer>
    </Modal>
  )
}
